import { render, staticRenderFns } from "./AddressbookNew.vue?vue&type=template&id=3e2dd930&scoped=true"
import script from "./AddressbookNew.vue?vue&type=script&lang=js"
export * from "./AddressbookNew.vue?vue&type=script&lang=js"
import style0 from "./AddressbookNew.vue?vue&type=style&index=0&id=3e2dd930&prod&scoped=true&lang=css"
import style1 from "./AddressbookNew.vue?vue&type=style&index=1&id=3e2dd930&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2dd930",
  null
  
)

export default component.exports